import React, { createRef } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { __WEB__, THEME, FONT, FONT_SIZE, COLOR } from '../../constants/styles';
import CloseButton from './close_button';
import FormFooter from './form/footer';

export default class Confirm extends React.PureComponent {
  render() {
    const confirmationOpts = this.props.confirmationOpts;

    return (
      <View style={styles.container}>
        <View style={styles.header}>
          <Text style={styles.title} adjustsFontSizeToFit={true} numberOfLines={1}>
            {confirmationOpts?.title}
          </Text>
          <CloseButton style={styles.closeBtnStyle} onPress={confirmationOpts.onCancelled} />
        </View>

        {!!confirmationOpts?.description ? (
          <View style={{ paddingHorizontal: 20, justifyContent: 'center' }}>
            <Text style={[styles.textContent, confirmationOpts.textStyle]}>
              {confirmationOpts?.description}
            </Text>
          </View>
        ) : (
          <View style={{ height: 20 }} />
        )}

        <FormFooter
          onCancel={confirmationOpts.onCancelled}
          onSave={confirmationOpts.onConfirmed}
          cancelLabel={confirmationOpts?.reject || 'Cancel'}
          saveLabel={confirmationOpts?.confirm}
          autoFocus={true}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    zIndex: 101,
    backgroundColor: COLOR.contrast,
    maxWidth: 600,
    minWidth: 350,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: COLOR.altContrast,
    paddingLeft: 50,
    height: 50,
  },
  title: {
    flex: 1,
    ...THEME.textBold,
    fontSize: FONT_SIZE.large,
    textAlign: 'center',
    zIndex: 1,
  },
  closeBtnStyle: {
    zIndex: 103,
    position: 'relative',
    marginHorizontal: 10,
    marginTop: 1,
    borderRadius: 5,
  },
  textContent: {
    ...THEME.textRegular,
    textAlign: 'center',
    marginHorizontal: 20,
    marginVertical: 30,
  },
});
